import { h, Fragment } from "preact";
import { useState, useEffect, useRef } from "preact/hooks";
import { AwaitStore } from "@hibas123/utils";

type Component = () => h.JSX.Element | h.JSX.Element[];

interface IModal {
   component: Component;
   actions: {};
}

const modalObservable = new AwaitStore<Component>(undefined);

export function showModal(modal: Component) {
   modalObservable.send(modal);
   console.log(modalObservable);

   return {
      close: () => {
         console.log(modalObservable.value, modal);
         if (modalObservable.value === modal) {
            modalObservable.send(undefined);
         }
      },
   };
}

export function ModalController() {
   const [modal, setModal] = useState(() => modalObservable.value);

   useEffect(() => {
      const db = (modal: Component) => {
         setModal(() => modal);
      };
      modalObservable.subscribe(db);
      return () => modalObservable.unsubscribe(db);
   }, []);

   console.log(modal);

   return (
      <div class="modal-controller" key={modal}>
         <div
            class={"bg" + (modal ? " active" : "")}
            onClick={(evt) => {
               modalObservable.send(undefined);
            }}
         ></div>
         {modal && <div className="modal">{modal()}</div>}
      </div>
   );
}
